import CloseIcon from 'components/icons/CloseIcon';

import { TEST_ID } from './constants';
import type { FunctionComponent, MouseEvent, Props } from './types';

import styles from './styles.module.scss';

const RemoveButton: FunctionComponent<Props> = ({ className = '', onClick, testId = TEST_ID }) => {
    const handleClick = (event: MouseEvent) => {
        event.stopPropagation();
        onClick?.();
    };

    return (
        <span
            className={`${className} ${styles.removeButton}`}
            data-testid={testId}
            onClick={handleClick}>
            <CloseIcon className={styles.closeIcon} />
        </span>
    );
};

export default RemoveButton;
